var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
		_vm.$s.Button,
		_vm.$s[("size_" + _vm.size)],
		_vm.$s[("shape_" + _vm.shape)],
		_vm.$s[("align_" + _vm.align)],
		( _obj = {}, _obj[_vm.$s.fullWidth] = _vm.fullWidth, _obj[_vm.$s.iconButton] = _vm.isSingleChild(), _obj[_vm.$s.loading] = _vm.loading, _obj )
	],style:(_vm.style),attrs:{"type":_vm.type,"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('m-loading',{class:_vm.$s.Loading}):_vm._e(),_vm._v(" "),_c('span',{class:_vm.$s.MainText},[_vm._t("default")],2),_vm._v(" "),(_vm.$scopedSlots.information)?_c('span',{class:_vm.$s.InformationText},[_vm._t("information")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }